import React from "react";
import Pipeline from "@/components/dashboard/Pipeline";
import PullToRefresh from "@/components/dashboard/PullToRefresh";
import { UP, DOWN, timeAgo } from "@/lib/format";

const IndexCard = ({ d }) => {
  const up = (d.change_pct ?? 0) >= 0;
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-[6px] shadow-xs p-3" data-testid={`mobile-index-${d.symbol}`}>
      <div className="text-[11px] font-semibold tracking-wide text-slate-500 truncate">{d.label}</div>
      <div className="font-mono text-[18px] font-black text-slate-900 tabular-nums mt-1 leading-none">
        {d.value !== null && d.value !== undefined ? Number(d.value).toLocaleString(undefined, { maximumFractionDigits: 2 }) : "—"}
      </div>
      <div className="font-mono text-[12px] font-bold tabular-nums flex items-center gap-1 mt-1" style={{ color: up ? UP : DOWN }}>
        <span className="text-[8px]">{up ? "▲" : "▼"}</span>
        {d.change_pct === null || d.change_pct === undefined ? "—" : `${Math.abs(d.change_pct).toFixed(2)}%`}
      </div>
    </div>
  );
};

const Stat = ({ label, value, color }) => (
  <div className="bg-white border border-[#E2E8F0] rounded-[6px] px-3 py-2.5">
    <div className="text-[10px] uppercase tracking-wide text-slate-400">{label}</div>
    <div className="font-mono text-[16px] font-black tabular-nums mt-0.5" style={{ color: color || "#0F172A" }}>{value}</div>
  </div>
);

export default function MobileMarkets({ status, indices, running, scan, onRefresh }) {
  return (
    <PullToRefresh onRefresh={onRefresh} className="flex-1 min-h-0 bg-[#F1F5F9] p-3 space-y-3" testid="mobile-markets">
      <div className="flex items-center gap-2 px-0.5">
        <span className={`w-2 h-2 rounded-full ${running ? "bg-[#0284C7] animate-pulse" : "bg-[#00873C]"}`} />
        <span className="font-bold text-[13px] tracking-[0.08em] uppercase text-slate-700">Engine {running ? "Active" : "Online"}</span>
        <span className="ml-auto font-mono text-[11px] text-slate-400">{status?.last_scan ? timeAgo(status.last_scan.finished_at) : "—"}</span>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <Stat label="Universe" value={status?.universe_counts?.total ?? "—"} />
        <Stat label="Analysed" value={status?.analysed_count ?? "—"} />
        <Stat label="Matched" value={status?.matched_count ?? 0} color="#00873C" />
        <Stat label="Watch" value={status?.monitor_count ?? 0} color="#D97706" />
        <Stat label="Hourly" value={status?.hourly_enabled ? "ARMED" : "OFF"} color={status?.hourly_enabled ? "#00873C" : "#94A3B8"} />
        <Stat label="Scanning" value={running ? `${scan?.processed ?? 0}/${scan?.total ?? 0}` : "IDLE"} color={running ? "#0284C7" : "#94A3B8"} />
      </div>

      <Pipeline stages={status?.stages || []} running={running} processed={scan?.processed} total={scan?.total} matches={scan?.matches} current={scan?.current} />

      <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 px-0.5 pt-1">Global Indices</div>
      {indices && indices.length ? (
        <div className="grid grid-cols-2 gap-2">
          {indices.map((d) => <IndexCard key={d.symbol} d={d} />)}
        </div>
      ) : (
        <div className="p-6 text-center font-mono text-[13px] text-slate-400">Loading market indices…</div>
      )}
    </PullToRefresh>
  );
}
